import React from "react";

export interface AlertPopoverProps {
  message: string;
  icon?: string;
  variant?: "warning" | "info" | "success" | "danger";
  onDismiss?: () => void;
  onRetry?: () => void;
  show: boolean;
}

/**
 * Generic alert popover that displays above the activity bar
 * Similar to the "tap to wake" popover but positioned at the bottom
 */
export const AlertPopover: React.FC<AlertPopoverProps> = ({
  message,
  icon = "⚠️",
  variant = "warning",
  onDismiss,
  onRetry,
  show,
}) => {
  if (!show) return null;

  const variantClass = variant !== "warning" ? `alert-popover--${variant}` : "";
  const clickHandler = onRetry || onDismiss;

  return (
    <div
      className={`alert-popover ${variantClass}`}
      style={{ cursor: clickHandler ? "pointer" : "default" }}
    >
      <span className="alert-popover-icon">{icon}</span>
      <span className="alert-popover-message" onClick={clickHandler}>
        {message}
      </span>
      {onDismiss && (
        <button
          className="alert-popover-dismiss"
          onClick={(e) => {
            e.stopPropagation();
            onDismiss();
          }}
          aria-label="Dismiss"
          title="Dismiss"
        >
          ×
        </button>
      )}
    </div>
  );
};
